module.exports = __webpack_public_path__ + "img/c93bfe1.gif";